import api from "../../Utils/interceptors";

export const getAllPurchaseRequisitions =
  (
    page,
    size,
    request_by = "",
    ceo_status = "",
    accounts_status = "",
    priority = "",
    created_month = ""
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: "GET_ALL_PURCHASE_REQUISITIONS_REQUEST",
      });
      const { data } = await api.get(
        `purchase-requisitions/all?page=${page}&size=${size}&request_by=${request_by}&ceo_status=${ceo_status}&accounts_status=${accounts_status}&priority=${priority}&created_month=${created_month}`
      );
      dispatch({
        type: "GET_ALL_PURCHASE_REQUISITIONS_SUCCESS",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "GET_ALL_PURCHASE_REQUISITIONS_FAILED",
        payload: error.response?.data?.message,
      });
    }
  };

export const getCurrentUserPurchaseRequisitions =
  (page, size, request_by = "") =>
  async (dispatch) => {
    try {
      dispatch({
        type: "GET_CURRENT_USER_PURCHASE_REQUISITIONS_REQUEST",
      });
      const { data } = await api.get(
        `purchase-requisitions/my?page=${page}&size=${size}&request_by=${request_by}`
      );
      dispatch({
        type: "GET_CURRENT_USER_PURCHASE_REQUISITIONS_SUCCESS",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "GET_CURRENT_USER_PURCHASE_REQUISITIONS_FAILED",
        payload: error.response?.data?.message,
      });
    }
  };

export const createPurchaseRequisition =
  (requisitionData) => async (dispatch) => {
    try {
      dispatch({
        type: "CREATE_PURCHASE_REQUISITION_REQUEST",
      });

      const { data } = await api.post(
        "/purchase-requisition/create",
        requisitionData
      );

      dispatch({
        type: "CREATE_PURCHASE_REQUISITION_SUCCESS",
        payload: data,
        success: true,
      });
    } catch (e) {
      dispatch({
        type: "CREATE_PURCHASE_REQUISITION_FAILED",
        payload: e.response.data.message,
        success: false,
      });
    }
  };

export const getPurchaseRequisitionDetail =
  (requisition_id) => async (dispatch) => {
    try {
      dispatch({
        type: "GET_PURCHASE_REQUISITION_DETAIL_REQUEST",
      });
      const { data } = await api.get(`/purchase-requisition/${requisition_id}`);
      dispatch({
        type: "GET_PURCHASE_REQUISITION_DETAIL_SUCCESS",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "GET_PURCHASE_REQUISITION_DETAIL_FAILED",
        payload: error.response?.data?.message,
      });
    }
  };

export const deletePurchaseRequisition = (id) => async (dispatch) => {
  try {
    dispatch({
      type: "DELETE_PURCHASE_REQUISITION_REQUEST",
    });
    const { data } = await api.delete(`/purchase-requisition/${id}`);
    dispatch({
      type: "DELETE_PURCHASE_REQUISITION_SUCCESS",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "DELETE_PURCHASE_REQUISITION_FAILED",
      payload: error.response?.data?.message,
    });
  }
};

export const updatePurchaseRequisitionStatus =
  (requisition_id, status, approverType) => async (dispatch) => {
    try {
      dispatch({
        type: "UPDATE_PURCHASE_REQUISITION_STATUS_REQUEST",
      });
      const { data } = await api.put(
        `/purchase-requisition/confirmation/${requisition_id}`,
        {
          status,
          approverType,
        }
      );
      dispatch({
        type: "UPDATE_PURCHASE_REQUISITION_STATUS_SUCCESS",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "UPDATE_PURCHASE_REQUISITION_STATUS_FAILED",
        payload: error.response?.data?.message,
      });
    }
  };

export const sendPurchaseRequisitionComment =
  (requisition_id, comment) => async (dispatch) => {
    try {
      dispatch({
        type: "SEND_PURCHASE_REQUISITION_COMMENT_REQUEST",
      });
      const { data } = await api.put(
        `/purchase-requisition/comment/${requisition_id}`,
        {
          comment,
        }
      );
      dispatch({
        type: "SEND_PURCHASE_REQUISITION_COMMENT_SUCCESS",
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: "SEND_PURCHASE_REQUISITION_COMMENT_FAILED",
        payload: error.response?.data?.message,
      });
    }
  };
